// extracted by mini-css-extract-plugin
export var boxItems = "_64-1";
export var button = "_64-5";
export var filterGroupBox = "_64-0";
export var icon = "_64-2";
export var iconSecondary = "_64-4";
export var iconWrapper = "_64-3";